export default __webpack_public_path__ + "static/media/img-13.2828e661.jpg";